<template>
<div class="BuyResult">
    <div class="warp">
        <div v-if="courseData.payresult === 1" class="buy_success">
            <img class="tips_img" :src="require('@/common/images/header/success.png')" alt="">
            <p v-if="courseData.kmctype === 7" class="tips_text">您的订单购买成功，快去学习吧！</p>
            <p v-if="courseData.kmctype === 8" class="tips_text">您的订单购买成功，快去考试吧！</p>
            <p v-if="courseData.kmctype === 2" class="tips_text">您的订单购买成功，快去查看吧！</p>
            <p v-if="courseData.kmctype === 3" class="tips_text">您的订单购买成功，快去查看吧！</p>
            <div class="course_info_box">
                <img :src="courseData.coverurl" alt="">
                <span>{{courseData.subject}}</span>
            </div>
            <div class="handle_btn_box">
                <el-button @click="courseDetails" plain style="width: 160px;">{{buttontext}}</el-button>
                <el-button type="primary" v-if="courseData.kmctype===7"  @click="soonLearn" style="width: 160px;">马上学习</el-button>
                <el-button type="primary" v-if="courseData.kmctype===8" @click="courseDetails" style="width: 160px;">进入考试</el-button>
                <el-button type="primary" v-if="courseData.kmctype===2" @click="seeReport" style="width: 160px;">查看报告</el-button>
            </div>
        </div>
        <div v-if="courseData.payresult === 0" class="buy_error">
            <img class="tips_img" :src="require('@/common/images/header/error.png')" alt="">
            <p class="tips_text">您的订单待确定</p>
            <div class="course_info_box">
                <img :src="courseData.coverurl" alt="">
                <span>{{courseData.subject}}</span>
            </div>
            <div class="handle_btn_box">
                <el-button @click="courseDetails" plain style="width: 160px;">{{courseData.kmctype===8?'题库详情':(courseData.kmctype===2?'报告详情':'课程详情')}}</el-button>
                <el-button @click="repurchase" type="primary" style="width: 160px;">重新购买</el-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {queryorderpayresult} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'BuyResult',
    data() {
        return {
            // buyResult: '',
            courseData: {},
            buttontext:'课程详情'
        }
    },
    mounted() {
        // this.buyResult = this.$route.query.result
        console.log(this.buyResult)
        this.findOrderDetail()
    },
    methods: {
        // 获取订单信息（题库/课程）
        findOrderDetail() {
            this.setLoading(true);
            let params = {
                orderid: this.$route.query.orderid,
                result:this.$route.query.result,
                rid:this.$route.query.rid,
                sign:this.$route.query.sign,
            };
            queryorderpayresult({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.courseData = data.data
                    if(this.courseData.kmctype===8){
                        this.buttontext='题库详情'
                    }else if(this.courseData.kmctype===2){
                        this.buttontext='报告详情'
                    }else if(this.courseData.kmctype===3){
                        this.buttontext='直播详情'
                    }else{
                        this.buttontext='课程详情'
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 题库/课程详情、进入考试/报告详情
        courseDetails() {
            if(this.courseData.kmctype===8){
                this.$router.push({name: 'QuestionDetails', query: {'qid': this.courseData.courseid}})
            }else if(this.courseData.kmctype===2){
                this.$router.push({name: 'ReportDetails', query: {'reportid': this.courseData.courseid}})
            }else if(this.courseData.kmctype===3){
                this.$router.push({name: 'VideoLiveing', query: {'innerid': this.courseData.courseid}})
            }else{
                this.$router.push({name: 'CourseDetails', query: {'cid': this.courseData.courseid}})
            }
        },
        // 查看报告
        seeReport(){
            this.$router.push({name: 'ReportPreview', query: {'reportid': this.courseData.courseid,retype:1}})
        },
        // 马上学习
        soonLearn() {
            this.$router.push({name: 'Study', query: {'courseid': this.courseData.courseid}})
        },
        // 重新购买
        repurchase () {
            this.$router.push({name: 'OrderIndex', query: {'kmcinnerid': this.courseData.courseid,kmctype:this.courseData.kmctype}})
            // if(this.courseData.kmctype===8){
            //     this.$router.push({name: 'OrderIndex', query: {'qid': this.courseData.courseid,kmctype:8}})
            // }else if(this.courseData.kmctype===2){
            //     this.$router.push({name: 'OrderIndex', query: {'reportid': this.courseData.courseid,kmctype:2}})
            // }else{
            //     this.$router.push({name: 'OrderIndex', query: {'cid': this.courseData.courseid}})
            // }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(
            ['loginPop', 'user']
        )
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.BuyResult {
    // margin-top: 80px;
    .warp {
        font-family:PingFangSC-Medium,PingFang SC;
        color: #333;
        width: 960px;
        margin: 0 auto;
        .buy_success, .buy_error {
            padding-top: 80px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .tips_img {
                width: 56px;
                height: 56px;
                margin-bottom: 20px;
            }
            .tips_text {
                margin-bottom: 30px;
                font-size:16px;
                line-height:22px;
            }
            .course_info_box {
                display: flex;
                align-items: center;
                width: 445px;
                height: 94px;
                background-color: #F5F5F5FF;
                padding: 0 20px;
                box-sizing: border-box;
                &>img {
                    width:124px;
                    height:70px;
                    border-radius:4px;
                    margin-right: 20px;
                }
                &>span {
                    font-size:14px;
                    line-height:20px;
                }
            }
            .handle_btn_box {
                margin-top: 60px;
                .el-button+.el-button {
                    margin-left: 30px;
                }
            }
        }
    }
}
</style>